import Button from './components/button'
import multipay from './components/multipay'

if (global.Komoju === undefined) {
  const currentScript = document.currentScript || (function () {
    let scripts = document.getElementsByTagName('script')
    return scripts[scripts.length - 1]
  })()

  if (Object.keys(currentScript.dataset)) {
    let button = new Button(multipay)
    button.render()
  }

  global.Komoju = { checkout: multipay, multipay: multipay }
} else {
  throw new Error('only one instance of Komoju is allowed.')
}



// WEBPACK FOOTER //
// ./src/api/index.js